/**
 * The rules of a stacked search, free of React: what a kept search looks like, when Enter adds one, and the
 * lower-cased needles a list is filtered by. `useSearchTerms` holds the state; these decide it.
 */

/** "  Senior   IC " → "Senior IC": a kept search as its chip shows it. */
export const tidySearchTerm = (text: string): string => text.trim().replace(/\s+/g, " ");

const needleOf = (text: string): string => tidySearchTerm(text).toLocaleLowerCase();

export type AddSearchTermResult = { kind: "blank" } | { kind: "duplicate"; index: number } | { kind: "added"; terms: string[] };

/** Enter on `text`: nothing for a blank box, the chip it repeats (any case or spacing), or the new list. */
export const addSearchTerm = (terms: string[], text: string): AddSearchTermResult => {
	const needle = needleOf(text);
	if (needle === "") return { kind: "blank" };
	const index = terms.findIndex((term) => needleOf(term) === needle);
	return index === -1 ? { kind: "added", terms: [...terms, tidySearchTerm(text)] } : { kind: "duplicate", index };
};

/**
 * What a list is filtered by: every kept search plus what is still being typed, lower-cased, blanks and repeats
 * dropped. A row must match each one; an empty result keeps every row.
 */
export const searchNeedles = (terms: string[], text: string): string[] => [...new Set([...terms, text].map(needleOf).filter((needle) => needle !== ""))];
